// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"e64bc3c335d8c3cc1d10","655":"f536cf3b67dd113e4ddc"}[chunkId] + ".js";
};